import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const AddressIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M4 3C2.895 3 2 3.895 2 5V19C2 20.105 2.895 21 4 21H16H20C21.0931 21 22 20.0931 22 19V9C22 7.90694 21.0931 7 20 7H16V5C16 3.895 15.105 3 14 3H4ZM6.5 7H7.5C7.776 7 8 7.224 8 7.5V8.5C8 8.776 7.776 9 7.5 9H6.5C6.224 9 6 8.776 6 8.5V7.5C6 7.224 6.224 7 6.5 7ZM10.5 7H11.5C11.776 7 12 7.224 12 7.5V8.5C12 8.776 11.776 9 11.5 9H10.5C10.224 9 10 8.776 10 8.5V7.5C10 7.224 10.224 7 10.5 7ZM16 9H20V19H16V17H17.5C17.776 17 18 16.776 18 16.5V15.5C18 15.224 17.776 15 17.5 15H16V13H17.5C17.776 13 18 12.776 18 12.5V11.5C18 11.224 17.776 11 17.5 11H16V9ZM6.5 11H7.5C7.776 11 8 11.224 8 11.5V12.5C8 12.776 7.776 13 7.5 13H6.5C6.224 13 6 12.776 6 12.5V11.5C6 11.224 6.224 11 6.5 11ZM10.5 11H11.5C11.776 11 12 11.224 12 11.5V12.5C12 12.776 11.776 13 11.5 13H10.5C10.224 13 10 12.776 10 12.5V11.5C10 11.224 10.224 11 10.5 11ZM6.5 15H7.5C7.776 15 8 15.224 8 15.5V16.5C8 16.776 7.776 17 7.5 17H6.5C6.224 17 6 16.776 6 16.5V15.5C6 15.224 6.224 15 6.5 15ZM10.5 15H11.5C11.776 15 12 15.224 12 15.5V16.5C12 16.776 11.776 17 11.5 17H10.5C10.224 17 10 16.776 10 16.5V15.5C10 15.224 10.224 15 10.5 15Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

AddressIcon.propTypes = {
  sx: PropTypes.object,
};

export default AddressIcon;
